import './App.css'
import {EulaPopup} from "./eula/EulaPopup.tsx";
import {AppSwitcher} from "./AppSwitcher.tsx";

function App() {
  return (
    <>
        <EulaPopup />
        <AppSwitcher />
    </>
  )
}

export default App
